import api from "./apiLogisticsTool.js";

export default {  

  GetOperatorProcedure(id) {
    return api.get("OperatorsProcedures/GetOperatorProcedure/" + id);
  },

  InsertOperatorProcedure(vop) {
    return api.post("OperatorsProcedures/InsertOperatorProcedure", vop);
  },

  UpdateOperatorProcedure(vop) {
    return api.put("OperatorsProcedures/UpdateOperatorProcedure", vop);
  },  

  GetOperatorsProcedures() {
    return api.get("OperatorsProcedures/GetOperatorsProcedures");
  },

  DeleteOperatorProcedure(id) {
    return api.delete("OperatorsProcedures/DeleteOperatorProcedure", id);
  },
};
